import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

function HomePage() {
  const [todayCnt, setTodayCnt] = useState();
  const [feedbackItems, setFeedbackItems] = useState([]);

  const emailInputRef = useRef();
  const feedbackInputRef = useRef();

  const isCalled = useRef(false);

   useEffect(() => {
    if (isCalled.current) return
    isCalled.current = true;

    // 언마운트 시 요청 취소를 위한 AbortController
    const controller = new AbortController();

     
    // 페이지 방문 시 IP 로깅 API 호출
    const logIp = async () => {
      try {
        //패스 인자 확인 필요
        const res = await fetch('/api/ip', {
          signal: controller.signal
        });
        
        if (!res.ok) {
          const errorText = await res.text();
          console.error('API Error', errorText);
          return;
        }

        const data = await res.json();
        console.log(`데이터 값 ${data}`)
        if (data.success) {
          console.log('data', data);
          setTodayCnt(data.ipcnt)

        } else {
          console.log('error', data);
        }
      } catch (err) {
        console.error('네트워크 에러:', err);
      }
    };
    logIp();

    // Cleanup 함수
    return () => {

    };
   }, []);

  // useEffect(() => {
  //   // 페이지 방문 시 IP 로깅 API 호출
  //   fetch('/api/ips')
  //     .then((res) => res.json())
  //     .then((data) => {
  //       if (data.success) {
  //         console.log('방문 기록 완료:', data.ip);
  //       }
  //     })
  //     .catch((err) => console.error('IP 로깅 에러:', err));
  // }, []);


  function submitFormHandler(event) {
    event.preventDefault();

    const enteredEmail = emailInputRef.current.value;
    const enteredFeedback = feedbackInputRef.current.value;

    const reqBody = {
      email: enteredEmail,
      feedback: enteredFeedback,
    };

    fetch('/api/feedback', {
      method: 'POST',
      body: JSON.stringify(reqBody),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => console.log(data));
  }

  function loadFeedbackHandler() {
    fetch('/api/feedback')
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setFeedbackItems(data.feedback);
      });
  }

  return (
    <div>
      { todayCnt !== null && <p>오늘 방문자수: {todayCnt} </p>}

      <h1>The Home Page</h1>
      <p><Link href="/gd">🎮 지오메트리 대쉬 트리거 가이드 보기</Link></p>
      <form onSubmit={submitFormHandler}>
        <div>
          <label htmlFor="email">Your Email Address</label>
          <input type="email" id="email" ref={emailInputRef} />
        </div>
        <div>
          <label htmlFor="feedback">Your feedback</label>
          <textarea id="feedback" rows="5" ref={feedbackInputRef} />
        </div>
        <button type="submit">Send Feedback</button>
      </form>
      <hr />
      {/*
        <button type="button" onClick={loadFeedbackHandler}>Load Feedback</button>
        <ul>
          {feedbackItems && feedbackItems.map((item) => (
            <li key={item.id}>
              {item.feedback} ({item.email})
            </li>
          ))}
        </ul>
      */}
    </div>
  );
}

// 빌드 시점에 서버 측 데이터를 가져오는 로직이 필요한 경우 작성
export async function getStaticProps() {
  return {
    props: {},
  };
}

export default HomePage;
